import { Form, Input, Modal, Radio, Select, DatePicker, message } from "antd";
import { UploadFile } from "antd/lib/upload/interface";
import React, { useContext, useEffect, useState } from "react";
import { BUTTON_PROPS } from "../../constants/general";
import AppContext from "../../context/app.context";
import { IAppContext } from "../../interfaces/context.interfaces";
import { IEvent, IServerEvent } from "../../interfaces/map.interfaces";
import { getNewEventId } from "../../utils/event.utils";
import MapDataContext from "../MapData/map.data.context";
import UploadImage from "./UploadImage";
import moment from "moment";
import {
  buildStationImageEntry,
  canShowStations,
  getHanEventTypes,
  getStationImageUploadKey,
  isHanProject,
  isStationEvent,
} from "../../utils/station.utils";

function UpdateEventForm({
  event,
  visible,
  setVisible,
  refreshEvents,
}: {
  event: IEvent;
  visible: boolean;
  setVisible: Function;
  refreshEvents: Function;
}) {
  const appContext: IAppContext = useContext(AppContext);
  const mapDataContext = useContext(MapDataContext);

  const [language, setLanguage] = useState<string>(null);
  const [subTypeEnabled, setSubTypeEnabled] = useState<boolean>(null);
  const [types, setTypes] = useState<string[]>();
  const [subTypes, setSubTypes] = useState<string[]>();
  const [author, setAuthor] = useState<string>();

  const [currentEventState, setCurrentEventState] = useState<string>();
  const [currentTypeState, setCurrentTypeState] = useState<string>();
  const [currentSubTypeState, setCurrentSubTypeState] = useState<string>();

  const [newEventState, setNewEventState] = useState<string>();
  const [newTypeState, setNewTypeState] = useState<string>();
  const [newSubTypeState, setNewSubTypeState] = useState<string>();
  const [newEventDate, setNewEventDate] = useState<any>(null);
  const [newEventComment, setNewEventComment] = useState<string>("");
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const [imageFile, setImageFile] = useState<UploadFile>(null);
  const { Option } = Select;

  useEffect(() => {
    appContext.services.userService.getMyData().then((data) => {
      setLanguage(data.data.language);
      setAuthor(data.data.email);
    });
    appContext.services.projectService.getMyData().then((data) => {
      setSubTypeEnabled(data.data[0].subTypeEnabled);
      setSubTypes(data.data[0].subTypes);
      setTypes(data.data[0].types);
    });
  }, []);

  const getOptions = (options: string[]) => {
    let optionsArr = [];
    const typeOptions = isHanProject(appContext.projects?.id) && canShowStations()
      ? getHanEventTypes(options)
      : options;
    if (typeOptions) {
      for (const option of typeOptions) {
        optionsArr.push(
          <Option key={option} value={option}>
            {option}
          </Option>
        );
      }
    }

    return optionsArr;
  };

  const onEditEvent = async (
    previousEvent: IServerEvent,
    newType: string,
    newSubType: string,
    newState: string,
    newComment: string,
    author: string,
    newDate: string = null
  ) => {
    if (!newComment) {
      if (newType !== previousEvent.properties.type) {
        newComment = `Type: ${newType}\t`;
      }
      if (newSubType !== previousEvent.properties.subType) {
        newComment = newComment + `Sub Type: ${newSubType}\t`;
      }
      if (newState !== previousEvent.properties.state) {
        newComment = newComment + `State: ${newState}`;
      }
    }

    // if (newTypeState === "Kronenschlüsse") {
    //   console.log("Here")
    //   appContext.services.crownClosureService.updateEvent(
    //     previousEvent,
    //     newType,
    //     newSubType,
    //     newState,
    //     newComment,
    //     author)
    //   } 

    // console.log(appContext.projects.app)

    // if (appContext.projects.app === "red") {
    //   console.log("red")

    //   appContext.services.liaEventService.updateEvent (
    //     previousEvent,
    //     newType,
    //     newSubType,
    //     newState,
    //     newComment,
    //     author)
    // } else {
    //   console.log("pipeline")

    //   mapDataContext.updateEvent(
    //     previousEvent,
    //     newType,
    //     newSubType,
    //     newState,
    //     newComment,
    //     author
    //   );
    // }}
    
    // mapDataContext.updateEvent(
    //     previousEvent,
    //     newType,
    //     newSubType,
    //     newState,
    //     newComment,
    //     author
    //   );

    try {
      if (newTypeState === "Kronenschlüsse") {
        await appContext.services.crownClosureService.updateEvent(
          previousEvent,
          newType,
          newSubType,
          newState,
          newComment,
          author,
          newDate
        );
      } else if (appContext.projects?.app === "red") {
        await appContext.services.liaEventService.updateEvent(
          previousEvent,
          newType,
          newSubType,
          newState,
          author,
          newComment,
          newDate
        );
      } else {
        await Promise.resolve(
          mapDataContext.updateEvent(
            previousEvent,
            newType,
            newSubType,
            newState,
            newComment,
            author,
            newDate
          )
        );
      }

      if (imageFile?.originFileObj) {
        if (isStationEvent(previousEvent.properties)) {
          const uploadKey =
            previousEvent.properties.images?.[
              previousEvent.properties.images.length - 1
            ]?.key || `${previousEvent.properties.id}.png`;
          appContext.services.imageService.uploadImage(
            imageFile.originFileObj as File,
            uploadKey
          );
        } else {
          appContext.services.imageService.uploadImage(
            imageFile.originFileObj as File,
            previousEvent.properties.image
          );
        }
      }
      setTimeout(() => {
        refreshEvents();
      }, 1000);
      message.success(
        language === "de"
          ? "Ereignis erfolgreich aktualisiert."
          : "Event updated successfully."
      );
    } catch (error) {
      message.error(
        language === "de"
          ? "Ereignis konnte nicht aktualisiert werden."
          : "Failed to update event."
      );
    }
  };

  const handleOk = (event: IEvent) => {
    setConfirmLoading(true);

    setTimeout(() => {
      const newEventId = getNewEventId(event.properties.id);
      const stationEvent = isStationEvent(event.properties);
      const dateToSave = newEventDate
        ? newEventDate.format("YYYY-MM-DD")
        : stationEvent && imageFile
        ? moment().format("YYYY-MM-DD")
        : null;
      const existingImages = event.properties.images || [];
      let nextImages = [...existingImages];

      if (stationEvent && imageFile) {
        const uploadKey = getStationImageUploadKey(newEventId, existingImages);
        nextImages = [
          ...existingImages,
          buildStationImageEntry(
            uploadKey,
            dateToSave,
            newEventComment || imageFile.name || uploadKey,
            author
          ),
        ];
      } else if (stationEvent) {
        nextImages = [...existingImages];
      }

      let previousEvent = {
        properties: {
          ...event.properties,
          id: newEventId,
          image: stationEvent
            ? ""
            : imageFile
            ? newEventId + ".png"
            : event.properties.image || "",
          images: stationEvent ? nextImages : event.properties.images,
        },
        geometry: {
          type: event.type,
          coordinates: event.coordinates,
        },
      };

      onEditEvent(
        previousEvent,
        newTypeState,
        newSubTypeState,
        newEventState,
        newEventComment,
        author,
        dateToSave
      );

      setVisible(false);
      setConfirmLoading(false);
    }, 2000);
  };

  const handleCancel = () => {
    setNewSubTypeState("");
    setNewTypeState("");
    setNewEventState("");
    setNewEventDate(null);
    setNewEventComment("");
    setCurrentEventState("");
    setCurrentTypeState("");
    setCurrentSubTypeState("");
    setVisible(false);
    setImageFile(null);
  };

  useEffect(() => {
    if (!visible) return;
    setNewSubTypeState(event.properties.subType ?? "");
    setNewTypeState(event.properties.type);
    setNewEventState(event.properties.state);
    setNewEventDate(null);
    setCurrentEventState(event.properties.state);
    setCurrentTypeState(event.properties.type);
    setCurrentSubTypeState(event.properties.subType ?? "");
    setImageFile(null);
  }, [event, visible]);

  return (
    <Modal
      title={language === "de" ? "Bearbeiten" : "Edit"}
      className="MapDeckComment"
      centered
      okText={"Submit"}
      visible={visible}
      onOk={() => {
        handleOk(event);
      }}
      confirmLoading={confirmLoading}
      onCancel={handleCancel}
      okButtonProps={{
        type: "primary",
        shape: "round",
        size: "small",
        disabled:
          newEventComment || imageFile
            ? false
            : currentEventState === newEventState &&
              currentSubTypeState === newSubTypeState &&
              currentTypeState === newTypeState,
      }}
      cancelButtonProps={{
        ...BUTTON_PROPS,
        type: "danger",
        shape: "round",
        size: "small",
      }}
    >
      <Form onClick={(e) => e.stopPropagation()}>
        {newTypeState !== "Kronenschlüsse" ? <Form.Item label={language === "de" ? "Status" : "State"}>
          <Radio.Group
            defaultValue={newEventState}
            onChange={(e) => setNewEventState(e.target.value)}
            value={newEventState}
          >
            <Radio.Button value={"active"}>
              {language === "de" ? "Aktiv" : "Active"}
            </Radio.Button>
            <Radio.Button value={"only report change"}>
              {language === "de" ? "Nur Änderung Melden" : "Only Report Change"}
            </Radio.Button>
            <Radio.Button value={"archived"}>
              {language === "de" ? "Archiv" : "Archive"}
            </Radio.Button>
            <Radio.Button value={"do not report"}>
              {language === "de" ? "Nicht Mehr Melden" : "Do Not Report"}
            </Radio.Button>
          </Radio.Group>
        </Form.Item> 
        : 
        <Form.Item label={language === "de" ? "Status" : "State"}>
          <Radio.Group
            defaultValue={newEventState}
            onChange={(e) => setNewEventState(e.target.value)}
            value={newEventState}
          >
            <Radio.Button value={"checked"}>
              {language === "de" ? "Checked" : "Checked"}
            </Radio.Button>
            <Radio.Button value={"unchecked"}>
              {language === "de" ? "Un-checked" : "Un-checked"}
            </Radio.Button>
          </Radio.Group>
        </Form.Item>}
        
        {newTypeState !== "Kronenschlüsse" ? <Form.Item label={language === "de" ? "Typ" : "Type"}>
          <Select
            style={{ width: 200 }}
            defaultValue={newTypeState}
            onChange={(value) => setNewTypeState(value)}
            value={newTypeState}
          >
            {getOptions(types)}
          </Select>
        </Form.Item> : 
        <Form.Item label={language === "de" ? "Typ" : "Type"}>
          <Select
              style={{ width: 200 }}
              value="Kronenschlüsse"
              disabled
          >
              <Select.Option value="Kronenschlüsse">Kronenschlüsse</Select.Option>
          </Select>
        </Form.Item>}
        
        <span hidden={!subTypeEnabled}>
          <Form.Item label={language === "de" ? "Sub Typ" : "SubType"}>
            <Select
              style={{ width: 200 }}
              defaultValue={newSubTypeState}
              onChange={(value) => setNewSubTypeState(value)}
              value={newSubTypeState}
            >
              {getOptions(subTypes)}
            </Select>
          </Form.Item>
        </span>
        <Form.Item label={language === "de" ? "Datum" : "Date"} style={{ marginBottom: 0 }}>
          <DatePicker
            style={{ width: "100%" }}
            value={newEventDate}
            onChange={(date) => setNewEventDate(date)}
            format="YYYY-MM-DD"
            placeholder={language === "de" ? "Datum auswählen (optional)" : "Select date (optional)"}
            allowClear
          />
        </Form.Item>
        <Form.Item label={language === "de" ? "Kommentar" : "Comment"}>
          <Input
            placeholder={
              language === "de"
                ? "Schreiben Sie Ihren Kommentar..."
                : "Write your comment..."
            }
            value={newEventComment}
            onChange={(e) => setNewEventComment(e.target.value)}
          />
        </Form.Item>
        <Form.Item label={language === "de" ? "Bearbeiter" : "Editor"}>
          <Input
            placeholder={language === "de" ? "Name des Autors" : "Author Name"}
            value={author}
            onChange={(e) => setAuthor(e.target.value)}
          />
        </Form.Item>
      </Form>
      {newTypeState !== "Kronenschlüsse" ? <UploadImage
        setFile={setImageFile}
        file={imageFile?.originFileObj as File}
      /> : null}   
      
    </Modal>
  );
}

export default UpdateEventForm;
